<template>
  <fragment>
    <p
      v-if="hintVisible"
      :id="tipId"
      v-tooltip="{
        content: tooltipContent,
        html: true,
      }"
      class="hint-i"
      tabindex="0"
      :triggers="['hover', 'focus', 'touch', 'click']"
    />
    <button
      v-else
      :id="tipId"
      v-tooltip="{
        content: tooltipContent,
        html: true,
      }"
      :class="buttonClasses"
      :style="buttonStyle"
      :aria-label="text"
      tabindex="0"
      :triggers="['hover', 'focus', 'touch', 'click']"
      @click="buttonClicked"
    />
  </fragment>
</template>
<script>
import {PLACEMENTS} from 'uiv/src/utils/domUtils'
import {Fragment} from 'vue-fragment'

export default {
  name: 'PortalTooltip',
  components: { Fragment},
  props: {
    tipId: undefined,
    buttonClasses: {
      type: String,
      default: 'btn btn-default btn-sm'
    },
    buttonStyle: {
      type: String,
      default: undefined
    },
    placement: {
      type: String,
      default: PLACEMENTS.TOP
    },
    text: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: undefined
    },
    hintVisible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tooltipContent: this.makeTooltip()
    }
  },
  watch: {
    text() {
      this.tooltipContent = this.makeTooltip()
    }
  },
  methods: {
    makeTooltip() {
      return ''
        + '<div class="my-tooltip"       ' +
        '      tabindex="0"\n' +
        '      role="tooltip"\n' +
        '      aria-live="polite">'
        + this.text
        + (this.image === undefined
          ? ''
          : '<img alt=tooltip class=img-responsive src=' + this.image + '>'
        )
        + '</div>'
    },
    buttonClicked() {
      this.$emit('buttonClicked')
    }
  }
}
</script>
<style>
  .v-popper__wrapper {
    max-width: 450px;
  }
</style>
